import nameof from "ts-nameof.macro";
import { PageDto } from "../common/interfaces/PageDto";

export const TaxpayerPinLabels = {
  Person: "Физическо лице",
  Entity: "Юридическо лице",
  Egn: "ЕГН",
  Lnch: "ЛН/ЛНЧ",
  NapNumber: "Сл. номер на НАП",
  Eik: "ЕИК по БУЛСТАТ на ФЛ",
  Bulstat: "ЕИК по БУЛСТАТ на ЮЛ",
};

export enum TaxpayerType {
  Person = "person",
  Entity = "entity",
}

export enum PersonTaxpayerType {
  Egn = "IND_EGN",
  Lnch = "IND_LNCH",
  NapNumber = "IND_SLNO",
}

export enum EntityTaxpayerType {
  Eik = "IND_BULSTAT",
  Bulstat = "BUS_BULSTAT",
}

export enum ReportStatus {
  PROCESSING = "processing",
  SUCCESS_NO_OBLIGATIONS = "processingNoObligations",
  SUCCESS_WITH_OBLIGATIONS = "processingWithObligations",
}

export type ObligationRequestDto = {
  userId?: number;
  taxpayerPin?: string;
  taxpayerPinType: string;
  documentTypeId?: number;
};

export type ObligationRequestResultDto = {
  taxpayerPin?: string;
  taxpayerPinType?: string;
  entryNumber?: string;
  entryDate?: Date;
};

export type ObligationResponseSearchDto = {
  taxpayerPin?: string;
  taxpayerPinType: string;
  requestDate?: Date;
  documentTypeId?: number;
  entryNumber?: string;
} & PageDto;

export type ObligationResponseSearchResultDto = {
  obligationResponseId: number;
  entryNumber: string;
  taxpayerPin: string;
  taxpayerPinType: string;
  requestDate: Date;
  documentType: string;
  reportStatus: string;
  reportStatusNomValue: string;
};

export type ObligationResponsePreviewDto = {
  taxpayerPin: string;
  taxpayerPinType: string;
  taxpayerName: string;
  publicExecutor: string;
  userName: string;
  userType: string;
  notaryNumber: number;
  documentType: string;
  reportDate: Date;
  obligations: ObligationDto[];
};

export type ObligationDto = {
  obligationType: string;
  iban: string;
  amount: number;
};

export const getTaxpayerPinLabel = (taxpayerPinType?: string): string => {
  if (taxpayerPinType === PersonTaxpayerType.Egn) {
    return TaxpayerPinLabels.Egn;
  } else if (taxpayerPinType === PersonTaxpayerType.Lnch) {
    return TaxpayerPinLabels.Lnch;
  } else if (taxpayerPinType === PersonTaxpayerType.NapNumber) {
    return TaxpayerPinLabels.NapNumber;
  } else if (taxpayerPinType === EntityTaxpayerType.Eik) {
    return TaxpayerPinLabels.Eik;
  } else if (taxpayerPinType === EntityTaxpayerType.Bulstat) {
    return TaxpayerPinLabels.Bulstat;
  } else return nameof(undefined);
};
